import './styles/Action.css'

const Action=({titulo,origen,action,disabled,icon,hover,msg})=>{
    return(
        <div className='menuActionOption'>
            <div className='compactAction '>
                
                <button  className={'tooltip-btn '+(origen!=='Login'  && origen!=='Red' && origen!=='Blanco' && origen!=='Cancelar' && origen!=='Green'  && origen!=='Azul' && origen!=='Cielo' && origen!=='Filtro' ?'buttonAction':'')+' act'+origen+' '+(disabled?'actDisabled':'')} onClick={action} >
                    {icon!=undefined?
                <img  src={"/iconos/"+icon+".png"}alt="Icono" style={{width:'20px',height:'20px',marginRight:'5px'}}/>:''
                }
                    {titulo}</button>
                     {hover!==undefined && hover?
           <div className='tooltip-btn-txt'>
                    {(msg!=undefined?msg:'')}
                </div>
           
            :''}
            </div>
            
        </div>
    )
}

export default Action